// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SimpleComponentRender_container__f6fHo {
  position: relative;
  /* border: 1px solid #d0d0d0;
  border-radius: 5px; */
  height: 99%;
  width: 99%;
}

.SimpleComponentRender_canvasContainer__vpeBY {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: white;
  border: 1px solid #d0d0d0;
  border-radius: 5px;
}
`, "",{"version":3,"sources":["webpack://./src/components/ThreeJS/ModelRender/SimpleComponentRender.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB;uBACqB;EACrB,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;AACpB","sourcesContent":[".container {\n  position: relative;\n  /* border: 1px solid #d0d0d0;\n  border-radius: 5px; */\n  height: 99%;\n  width: 99%;\n}\n\n.canvasContainer {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n  background: white;\n  border: 1px solid #d0d0d0;\n  border-radius: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `SimpleComponentRender_container__f6fHo`,
	"canvasContainer": `SimpleComponentRender_canvasContainer__vpeBY`
};
export default ___CSS_LOADER_EXPORT___;
